import '../../../src/docReady.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import './style.scss';

import Glide from '@glidejs/glide/dist/glide.min.js';
import '@glidejs/glide/src/assets/sass/glide.core.scss';
import '@glidejs/glide/src/assets/sass/glide.theme.scss';

const moduleSelector = '.eiovisual-cover';

var scrollTimer;

/**
 * Classe esempio
 */
class Module {

    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo mc cover');
    }
    
    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            if($modules && $modules.length>0) {
                $modules.forEach(($module) => {
                    new ModuleFeature($module);
                });
            }
        });
    }
}

class ModuleFeature {

    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    /**
     * Metodo di debounce, usato per addEventListener
     * @param {type} func
     * @param {type} delay
     * @returns {Function}
     */
    debounce(func, delay) {
        let inDebounce
        
        return () => {
            const context = this
            const args = arguments
            clearTimeout(inDebounce)
            inDebounce = setTimeout(() => func.apply(context, args), delay)
        }
    }

    // _________________________________________________________________________

    /**
     * Inizializza le tasks di questo modulo
     * @returns {undefined}
     */
    init_feature() {
        // Tasks on images
        if(!isMobile.check()) {
            setTimeout(() => { this.task1() },0);
            setTimeout(() => { this.task2() },1000);
        }
    }

    // _________________________________________________________________________

    /**
     * Inizializza il carousel Glide
     * @returns {undefined}
     */
    task1() {
        // init carousel
        this.images = this.get_images('.slideshow .item') || [];    

        this.carousel_init();

        return this;
    }

    // _________________________________________________________________________

    /**
     * Allo scroll switcha gli steps
     * @returns {undefined}
     */
    task2() {
        
        // quando scrolla:
        // - se scroll a 0, visualizza step 1
        // - se scroll > 1, visualizza step 2
        window.addEventListener('scroll', () => {

            // se il timer esiste, lo elimina
            if(scrollTimer) {
                window.clearTimeout(scrollTimer);
            }

            // esegue il controllo sullo scroll
            scrollTimer = window.setTimeout(this.switch_steps(), 100);
        });
    }

    // _________________________________________________________________________
    
    /**
     * Aggiorna il carousel
     * @returns {undefined}
     */
    carousel_update() {
        this.carousel.update({
            type: 'carousel',
            gap: 0,
            autoplay: 1000,
            animationDuration: 1000,
        });
    }

    /**
     * Inizializza il carousel
     * @returns {undefined}
     */
    carousel_init() {
        var that = this;
        
        this.carousel = new Glide('.glide').mount();
        
        // init
        this.carousel_update();
        
        // on window resize -> debounce -> carousel_update
        window.addEventListener('resize', this.debounce(() => {
            that.carousel_update();
        },1000)); // 1s di debounce
    }

    // _________________________________________________________________________

    /**
     * Restituisce l'elenco di immagini
     * 
     * @param selector
     * @return Array images url
     */
    get_images(selector) {
        
        let $this = this;

        docReady(() => {
        
            let $images = this.$module.querySelectorAll(selector);
            
            $images.forEach( ($image, index) => {
                let src = $image.getAttribute('src');
                $this.set_image(src);
            });

            return $this.images;
        });
    };

    // _________________________________________________________________________

    /**
     * Setta l'immagine
     * 
     * @param src
     * @returns String image src
     */
    set_image(src) {
        this.images.push({src: src});
        
        return src;
    }

    // _________________________________________________________________________
    
    /**
     * Restituisce lo scrollTop
     */
    get_scroll_top() {
        return document.documentElement.scrollTop || document.body.scrollTop;
    }
    
    // _________________________________________________________________________
    
    /**
     * Decide quale step attivare
     * @returns {undefined}
     */
    switch_steps() {
        let scroll_top = this.get_scroll_top();

        // attiva step 1
        if(scroll_top === 0) {
            this.step1();
        }
        
        // attiva step 2
        if(scroll_top > 0) {
            this.step2();
        }
    }
    
    // _________________________________________________________________________
    
    /**
     * Disattiva tutti gli step
     * @returns {undefined}
     */
    reset_step() {
        this.$module.querySelectorAll('.step').forEach((el,index) => {
            el.classList.remove('active');
        });
    }
    
    // _________________________________________________________________________
    
    /**
     * Attiva lo step 1
     * @returns {undefined}
     */
    step1() {
        this.reset_step();
        
        let $current_step = this.$module.querySelector('.step1');
        $current_step.classList.add('active');
    }
    
    // _________________________________________________________________________
    
    /**
     * Attiva lo step 2
     * @returns {undefined}
     */
    step2() {
        this.reset_step();
        
        let $current_step = this.$module.querySelector('.step2');
        $current_step.classList.add('active');
    }
   
}

// export
export default new Module();